import { Hero } from "@/components/home/Hero";
import { WhySwitch } from "@/components/home/WhySwitch";
import { Plotter } from "@/components/home/Plotter";
import { PricingSection } from "@/components/home/PricingSection";
import { FloatingPatterns } from "@/components/home/FloatingPatterns";

export default function Home() {
  return (
    <div className="relative" data-testid="home-page">
      <FloatingPatterns />
      <div className="relative">
        <Hero />
        <WhySwitch />
        <Plotter />
        <PricingSection />
      </div>
    </div>
  );
}
